import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import EditorContext from '../../containers/editor-context';
var AddImageDialog = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AddImageDialog, _React$PureComponent);
  var _super = _createSuper(AddImageDialog);
  function AddImageDialog(props) {
    var _this;
    _classCallCheck(this, AddImageDialog);
    _this = _super.call(this, props);
    _this.handleUrlChange = function (event) {
      _this.setState({
        url: event.target.value
      });
    };
    _this.handleSubmit = function (event) {
      _this.props.insertImage({
        url: _this.state.url,
        selection: _this.editorSelection
      });
      _this.props.onToggleImageDialog();
    };
    _this.state = {
      url: ''
    };
    _this.editorSelection = null;
    return _this;
  }
  _createClass(AddImageDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var editor = EditorContext.getEditor();
      this.editorSelection = editor.selection;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Modal, {
        isOpen: true,
        toggle: this.props.onToggleImageDialog,
        className: this.props.className,
        zIndex: 1071
      }, /*#__PURE__*/React.createElement(ModalHeader, {
        toggle: this.props.onToggleImageDialog
      }, this.props.t('insert_image')), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "columnName"
      }, this.props.t('image_address')), /*#__PURE__*/React.createElement(Input, {
        id: "columnName",
        value: this.state.value,
        onChange: this.handleUrlChange,
        autoFocus: true
      })))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
        color: "secondary",
        onClick: this.props.onToggleImageDialog
      }, this.props.t('cancel')), /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        disabled: this.state.url.length === 0,
        onClick: this.handleSubmit
      }, this.props.t('submit')), ' '));
    }
  }]);
  return AddImageDialog;
}(React.PureComponent);
export default withTranslation('seafile-editor')(AddImageDialog);